/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TransferSummaryBar.vue?vue&type=template&id=8f5e7402&scoped=true"
import script from "./TransferSummaryBar.vue?vue&type=script&lang=js"
export * from "./TransferSummaryBar.vue?vue&type=script&lang=js"
import style0 from "./TransferSummaryBar.vue?vue&type=style&index=0&id=8f5e7402&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5e7402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f5e7402')) {
      api.createRecord('8f5e7402', component.options)
    } else {
      api.reload('8f5e7402', component.options)
    }
    module.hot.accept("./TransferSummaryBar.vue?vue&type=template&id=8f5e7402&scoped=true", function () {
      api.rerender('8f5e7402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/TransferSummaryBar.vue"
export default component.exports